var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-template-add"},[_c('AddTemplate',{attrs:{"course_id":_vm.course_id},on:{"onSubmit":_vm.saveTemplate,"cancelCallBack":_vm.cancelCallBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }